import React from "react";
import "./Loader.css";

const Loader = ({ height = "300px", size = "50px", color = "#09558f" }) => {
  return (
    <div className="loader-container" style={{ minHeight: height }}>
      <div
        className="custom-loader"
        style={{
          width: size,
          height: size,
          borderTopColor: color,
        }}
      ></div>
    </div>
  );
};

export default Loader;
